module.exports = __webpack_public_path__ + "img/banner-zhirong.7361fb72.png";